import moment from "moment"

const DAYS_CRO = [ "Nedjelja", "Ponedjeljak", "Utorak", "Srijeda", "Četvrtak", "Petak", "Subota" ]
const MONTHS_CRO_DATE_FORMAT = [ 
    "Siječnja",
    "Veljače",
    "Ožujka",
    "Travnja",
    "Svibnja",
    "Lipnja",
    "Srpnja",
    "Kolovoza",
    "Rujna",
    "Listopada",
    "Studenog",
    "Prosinca",
]


export const getFullCroatianDate = (dateString: string) => {
    const date = moment(dateString);
    const dayCro = date.day()
    const day = date.format('DD');
    const month = date.month();
    const year = date.year();
    
    return `${DAYS_CRO[dayCro]}, ${day}. ${MONTHS_CRO_DATE_FORMAT[month]} ${year}.`

}


// WEBPACK FOOTER //
// ./src/utils/getFullCroatianDate.ts